import { render, staticRenderFns } from "./ReferralProgram.vue?vue&type=template&id=2f8f980d&scoped=true"
import script from "./ReferralProgram.vue?vue&type=script&lang=js"
export * from "./ReferralProgram.vue?vue&type=script&lang=js"
import style0 from "./ReferralProgram.vue?vue&type=style&index=0&id=2f8f980d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8f980d",
  null
  
)

export default component.exports